import { useHeader } from "../../../../context/HeaderContext";
import BottomMenu from "../../../../components/Dashboard/BottomMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  useGetPaymentInfoQuery,
  useSubmitPremiumPaymentProofMutation,
  useSubmitPremiumPlusPaymentProofMutation,
} from "../../../../services/addMoneyApi";
import { IoCopyOutline } from "react-icons/io5";
import { Notification } from "../../../../components/ToastNotification";
import InlineRefreshIndicator from "../../../../components/InlineRefreshIndicator";
import "./paymentMethods.css";
import { useGetSpecificUserPremium_PlusAmountQuery } from "../../../../services/userApi";
import { useGetAllPremiumCouponQuery } from "../../../../services/addMoneyApi";
import ViewMore from "./ViewMore";
import BottomSheetModal from "./BottomSheetModal";

const PremiumUPITransfer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { amount } = location.state || {};

  const [transactionId, setTransactionId] = useState("");
  const [singleFile, setSingleFile] = useState(null);
  const [discountedPrice] = useState(amount);
  const [fileUploading, setFileUploading] = useState(false);
  const { data: premiumplusamount } =
    useGetSpecificUserPremium_PlusAmountQuery();
  const discountedPremiumPlusPrice =
    premiumplusamount?.new_price_premium_plus ||
    premiumplusamount?.old_price_premium_plus;

  const {
    data: getcoupon,
    isLoading: loading,
    isError,
  } = useGetAllPremiumCouponQuery({});

  console.log("coupons", getcoupon);

  const coupons = getcoupon?.coupons || [];
  // premiumplusamount
  const isPremiumPlus = amount === discountedPremiumPlusPrice;

  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [visible, setVisible] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Slider navigation
  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredCoupons.length - 1 : prev - 1
    );
  };
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === filteredCoupons.length - 1 ? 0 : prev + 1
    );
  };

  // Filtered coupons (Premium or PremiumPlus)
  const filteredCoupons = coupons.filter(
    (coupon) =>
      !coupon.isHide &&
      (isPremiumPlus
        ? coupon.couponFor === "PremiumPlus"
        : coupon.couponFor === "Premium")
  );

  //  const { setScreenName } = useHeader();
  //    useEffect(() => {
  //        setScreenName("Upi Details");
  //        return () => {
  //          setScreenName(null);
  //        };
  //      }, []);
  const { data: paymentInfo, isLoading: paymentInfoLoading } =
    useGetPaymentInfoQuery();

  const [submitPremiumPaymentProof] = useSubmitPremiumPaymentProofMutation();

  const handleSubmit = async () => {
    if (singleFile) {
      try {
        setFileUploading(true);

        // Create FormData to send image file to backend
        const formData = new FormData();
        formData.append("file", singleFile);
        formData.append("transactionId", transactionId);
        formData.append("payment_mode", "upi_payment");
        formData.append("appliedCoupon", appliedCoupon?.couponId || null);
        formData.append("amount", amount);

        const response = await submitPremiumPaymentProof(formData);

        if (response.error) {
          Notification(response.error.data.message, "error");
        } else {
          Notification(
            `Request for Premium plan sent successfully`,
            "success"
          );
          setTransactionId("");
          setSingleFile(null);
        }
      } catch (error) {
        console.error("Error details:", error);
        Notification("An error occurred during submission", "error");
      } finally {
        setFileUploading(false);
      }
    } else {
      Notification("Payment proof image is required", "error");
    }
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    Notification("UPI ID Copied", "success");
  };

  const selectFile = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 3 * 1024 * 1024) {
      alert("Maximum size of images is 3 MB");
    } else {
      setSingleFile(file);
    }
  };

  return (
    // <div className="tpu__premium__wrapper layoutContainer">
    <div className="layoutContainer">
      {/* Header */}
      {/* Body content area */}
      <div className="tpu__premium__section__area">
        <div className="tpu-premium-upi-scroll-view">
          <div className="tpu-premium-upi-content">
            <div className="tpu-premium-upi-card">
              <p className="tpu-premium-upi-card-label">UPI ID:</p>
              <div className="tpu-premium-upi-card-row">
                <p className="tpu-premium-upi-card-value">
                  {paymentInfo?.data?.data?.payment_info[0][1]?.upi_info?.upi ||
                    "N/A"}
                </p>
                <IoCopyOutline
                  size={24}
                  color={"#007aff"}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    copyToClipboard(
                      paymentInfo?.data?.data?.payment_info[0][1]?.upi_info
                        ?.upi || ""
                    )
                  }
                />
              </div>
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Amount (INR)</label>
              <input
                className="tpu-premium-upi-input disabled-input"
                value={discountedPrice}
                readOnly
              />
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Transaction Id</label>
              <input
                className="tpu-premium-upi-input"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
                placeholder="Enter transaction id"
              />
            </div>

            <div className="tpu-premium-upi-input-container">
              <label className="tpu-premium-upi-label">Upload File</label>
              <button
                className="file-picker-btn"
                onClick={() => document.getElementById("upload-file").click()}
              >
                <input
                  type="file"
                  id="upload-file"
                  onChange={selectFile}
                  style={{ display: "none" }}
                />
                <span>
                  {singleFile?.name
                    ? singleFile.name.slice(0, 15)
                    : "Choose File"}
                </span>
              </button>
            </div>

            {singleFile && (
              <div className="file-preview">
                <img
                  src={URL.createObjectURL(singleFile)}
                  alt="File preview"
                  className="file-preview__image"
                />
                <div className="file-preview__info">
                  <span>{singleFile?.name}</span>
                </div>
              </div>
            )}

            <div className="tpu-premium-upi-button-container">
              <button
                className="tpu-premium-upi-button prev"
                onClick={() => navigate(-1)}
              >
                Prev
              </button>
              <button
                className={`tpu-premium-upi-button submit ${
                  !transactionId || !singleFile || fileUploading
                    ? "disabled"
                    : ""
                }`}
                disabled={!transactionId || !singleFile || fileUploading}
                onClick={handleSubmit}
              >
                {fileUploading ? "Uploading..." : "Submit"}
              </button>
            </div>
          </div>
          <div className="couponBox">
            {/* Coupon Slider */}
            {!loading && (
              <div className="coupon-section">
                <span style={{ alignSelf: "flex-start" }}>
                  Got a coupon code?{" "}
                  <span
                    onClick={() => {
                      setVisible(true);
                    }}
                    style={{ color: "purple", cursor: "pointer" }}
                  >
                    Apply
                  </span>
                </span>

                {isError || filteredCoupons.length === 0 ? (
                  <p>No Coupons Available</p>
                ) : (
                  <>
                    <div className="slider-wrapper">
                      <button className="nav-btn prev" onClick={handlePrev}>
                        &#10094;
                      </button>

                      <div
                        className="coupon-slider"
                        style={{
                          transform: `translateX(-${currentIndex * 100}%)`,
                        }}
                      >
                        {filteredCoupons.map((coupon) => (
                          <div
                            key={coupon._id}
                            className="coupon-card-container"
                          >
                            <div className="coupon-card">
                              <div className="coupon-content">
                                <span>
                                  <span
                                    className="coupon-code"
                                    style={{
                                      fontFamily: "'Poppins', sans-serif",
                                      fontWeight: 900,
                                    }}
                                  >
                                    {coupon.couponText}
                                  </span>
                                </span>
                                <button
                                  onClick={() => setAppliedCoupon(coupon)}
                                  className="apply-btn"
                                  disabled={
                                    appliedCoupon?.couponId === coupon.couponId
                                  }
                                >
                                  {appliedCoupon?.couponId ===
                                  coupon.couponId ? (
                                    <strong
                                      style={{
                                        backgroundColor: "gray",
                                        border: "1px solid gray",
                                      }}
                                    >
                                      Applied
                                    </strong>
                                  ) : (
                                    <strong>APPLY</strong>
                                  )}
                                </button>
                              </div>

                              <div className="DescriptionContainer">
                                <p className="coupon-description">
                                  Get {coupon.value} Points OFF
                                </p>
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setOpen(true);
                                    setSelectedCoupon(coupon);
                                  }}
                                  className="ViewMore"
                                >
                                  View More
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <button className="nav-btn next" onClick={handleNext}>
                        &#10095;
                      </button>
                    </div>

                    <div className="dot-container">
                      {filteredCoupons.map((_, idx) => (
                        <span
                          key={idx}
                          className={`dot ${
                            idx === currentIndex ? "active" : ""
                          }`}
                          onClick={() => setCurrentIndex(idx)}
                        />
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          <ViewMore
            open={open}
            setOpen={setOpen}
            coupon={selectedCoupon}
            setSelectedCoupon={setSelectedCoupon}
            setAppliedCoupon={setAppliedCoupon}
          ></ViewMore>
          <BottomSheetModal
            visible={visible}
            isPremiumPlus={isPremiumPlus}
            onClose={() => {
              setVisible(false);
            }}
            allCoupons={coupons}
            setAppliedCoupon={setAppliedCoupon}
          ></BottomSheetModal>
        </div>
      </div>
    </div>
  );
};

export default PremiumUPITransfer;
